import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { DprCard } from '@dpr/models';
import { UntilDestroy } from '@ngneat/until-destroy';

import {
  Approver,
  OnlineApprover,
  SubprojectConfigurationCustomNames,
} from '@shared/models/project-setup';

@UntilDestroy()
@Component({
  selector: 'app-dpr-list',
  templateUrl: './dpr-list.component.html',
  styleUrls: ['./dpr-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DprListComponent {
  //#region Inputs

  @Input({ required: true }) dprCards: DprCard[];
  @Input({ required: true }) canEdit: boolean;
  @Input({ required: true }) approvers: Approver[];
  @Input({ required: true }) onlineApprovers: OnlineApprover[];
  @Input({ required: true }) accountId: string;
  @Input({ required: true }) clientId: string;
  @Input({ required: true }) clientName: string;
  @Input({ required: true }) isDigitalSignatureEnabled: boolean;
  @Input({ required: true }) canEditExternalPartyComment: boolean;
  @Input({ required: true }) customNames: SubprojectConfigurationCustomNames;
  @Input({ required: true }) isAppOnline: boolean;
  @Input({ required: true }) isLoadingInProgress: boolean;
  @Input({ required: true }) isFullScreenMode: boolean;

  //#endregion

  //#region Outputs
  @Output() scrolled = new EventEmitter();

  //#endregion

  // trigger the scroll event when 80% (100% - 20%) of
  // the window has been scrolled
  distance = 2;

  // trigger the event this many milliseconds after the user stops scrolling
  throttle = 0;

  // selector of the parent container that is being scrolled
  // this is important if we want to listen to the window scroll
  // instead of the actual element scroll (scrollWindow = true)
  scrollContainer = '.main-container';

  onScroll(): void {
    this.scrolled.emit();
  }

  trackDprCard(_index: number, dprCard: DprCard): number | string {
    return dprCard?.id;
  }
}
